
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakkereiser/resultat",
      function () {
        return require("private-next-pages/pakkereiser/resultat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakkereiser/resultat"])
      });
    }
  